module.exports = __webpack_public_path__ + "img/1.42653756.jpg";